import { TicketType } from './TicketType';
import { DtoTicketPricingTier } from './DtoTicketPricingTier';
import { DtoTicketFieldItem } from './DtoTicketFieldItem';
import { DtoTicketPricingByDate, createDtoTicketPricingByDate } from './DtoTicketPricingByDate'

export interface DtoTicket {
    id: number;
    name: string;
    price: number;
    tieredPricing: boolean;
    ticketPricingTiers: DtoTicketPricingTier[];
    pricingByDate: boolean;
    ticketPricingByDate: DtoTicketPricingByDate;

    numberAvailable: number;
    ticketType: TicketType;
    restrictionMessage: string | null;
    restrictionTitle: string | null;
    allowGuestAttendee: boolean;
    ticketFieldConfig: DtoTicketFieldItem[];
    displayOrder: number;
    categoryDisplayOrder: number;
    dependentTicketTypes: number[];
    unlockable: boolean;
    taxable: boolean;
    continuingEducationUnits: number | null;
    ceuTypes: string | null;
    seatsPerTicket: number;
    numberLeft: number;
    disableInvoicing: boolean;
    countdownPercent: number;
    active: boolean;
    paymentPlansEnabled: boolean;
}

export class Ticket implements DtoTicket {
    id!: number;
    name!: string;
    price!: number;
    tieredPricing!: boolean;
    ticketPricingTiers!: DtoTicketPricingTier[];
    pricingByDate!: boolean;
    ticketPricingByDate!: DtoTicketPricingByDate;
    numberAvailable!: number;
    ticketType!: TicketType;
    restrictionMessage!: string | null;
    restrictionTitle!: string | null;
    allowGuestAttendee!: boolean;
    ticketFieldConfig!: DtoTicketFieldItem[];
    displayOrder!: number;
    categoryDisplayOrder!: number;
    dependentTicketTypes!: number[];
    unlockable!: boolean;
    taxable!: boolean;
    continuingEducationUnits!: number;
    ceuTypes!: string | null;
    seatsPerTicket!: number;
    numberLeft!: number;
    disableInvoicing!: boolean;
    countdownPercent!: number;
    active!: boolean;
    paymentPlansEnabled!: boolean;

    constructor(dtoTicket: DtoTicket) {
        Object.assign(this, dtoTicket);
    }

    calculatePrice(quantityPurchased: number) {
        var actualPrice = this.price;

        if (this.tieredPricing && this.ticketPricingTiers) {
            this.ticketPricingTiers.forEach(ticketTier => {
                if (ticketTier.minimum <= quantityPurchased && (ticketTier.maximum == null || ticketTier.maximum >= quantityPurchased)) {
                    actualPrice = ticketTier.price;
                }
            });
        }

        return actualPrice;
    }

    calculateSubtotal(quantity: number) {
        return quantity * this.calculatePrice(quantity);
    }
}

export function createDtoTicket(dtoTicket?: DtoTicket | any) {
    let obj = <DtoTicket>{
        id: 0,
        name: '',
        numberAvailable: 0,
        tieredPricing: false,
        price: 0,
        ticketType: TicketType.Paid,
        ticketPricingTiers: [],
        pricingByDate: false,
        ticketPricingByDate: createDtoTicketPricingByDate(),
        restrictionMessage: null,
        restrictionTitle: null,
        allowGuestAttendee: true,
        ticketFieldConfig: [],
        displayOrder: 0,
        categoryDisplayOrder: 0,
        dependentTicketTypes: [],
        unlockable: false,
        taxable: false,
        continuingEducationUnits: 0,
        ceuTypes: '',
        seatsPerTicket: 1,
        numberLeft: 0,
        disableInvoicing: false,
        countdownPercent: 0,
        active: false,
        paymentPlansEnabled: false
    };

    if (dtoTicket) {
        Object.assign(obj, dtoTicket);
    }

    return new Ticket(obj);
}
